import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronRight } from '@fortawesome/free-solid-svg-icons';

const FilterPopup = ({ 
  routingPreference, 
  setRoutingPreference, 
  setShowFilterPopup 
}) => {
  return (
    <div style={{
      position: 'fixed',
      top: '35%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      backgroundColor: '#2A3075',
      color: '#fff',
      padding: '1.5rem',
      borderRadius: '8px',
      width: '320px',
      zIndex: 10001,
      boxShadow: '0 4px 10px rgba(0,0,0,0.3)',
    }}>
      <div style={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginBottom: '1rem'
      }}>
        <span style={{ fontWeight: 'bold', fontSize: '1rem' }}>
          <FontAwesomeIcon icon={faChevronRight} style={{ marginRight: '0.5rem' }} />
          Route Options
        </span>
        <button
          onClick={() => setShowFilterPopup(false)}
          style={{
            background: 'none',
            color: '#fff',
            border: 'none',
            fontSize: '18px',
            cursor: 'pointer'
          }}
        >
          ✕
        </button>
      </div>

      <div style={{ display: 'flex', justifyContent: 'space-between', gap: '1.5rem' }}>
        {/* Left: Prefer */}
        <div>
          <div style={{ fontWeight: 500, marginBottom: '0.5rem' }}>Prefer</div>
          <div><label><input type="checkbox" /> Bus</label></div>
          <div><label><input type="checkbox" /> Subway</label></div>
          <div><label><input type="checkbox" /> Train</label></div>
          <div><label><input type="checkbox" /> Light rail</label></div>
        </div>

        {/* Right: Routes */}
        <div>
          <div style={{ fontWeight: 500, marginBottom: '0.5rem' }}>Routes</div>
          <div>
            <label>
              <input
                type="radio"
                name="routeOption"
                checked={routingPreference === "BEST_ROUTE"}
                onChange={() => {
                  setRoutingPreference("BEST_ROUTE");
                  setShowFilterPopup(false);
                }}
                style={{ marginRight: '0.5rem' }}
              />
              Best route
            </label>
          </div>
          <div>
            <label>
              <input
                type="radio"
                name="routeOption"
                checked={routingPreference === "FEWER_TRANSFERS"}
                onChange={() => {
                  setRoutingPreference("FEWER_TRANSFERS");
                  setShowFilterPopup(false);
                }}
                style={{ marginRight: '0.5rem' }}
              />
              Fewer transfers
            </label>
          </div>
          <div>
            <label>
              <input
                type="radio"
                name="routeOption"
                checked={routingPreference === "LESS_WALKING"}
                onChange={() => {
                  setRoutingPreference("LESS_WALKING");
                  setShowFilterPopup(false);
                }}
                style={{ marginRight: '0.5rem' }}
              />
              Less walking
            </label>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FilterPopup; 